import React from 'react';

import { CoreIcon } from '@aspid/ui';
import { IconButton } from '@mui/material';

import { IconCollection } from '@components/icons/iconCollection';

import type { DeleteIconButtonProperties } from './DeleteIconButton.types';

export const DeleteIconButton: React.FC<DeleteIconButtonProperties> = ({
  onClick,
  disabled,
  dataTest = 'delete_icon_button',
  sx,
}) => (
  <IconButton
    data-testid={dataTest}
    size='small'
    onClick={onClick}
    disabled={disabled}
    name='delete'
    aria-label='delete'
    sx={{ p: 0.5, ...sx }}
  >
    <CoreIcon
      icon={IconCollection.trashCan}
      sx={{ fontSize: 14, cursor: 'pointer' }}
      color='action'
    />
  </IconButton>
);
